import { connect } from 'react-redux';
import styled from 'styled-components';

import MeasurementComparison from 'modules/common/viewer/cadViewer/addOns/MeasurementComparisonDisplay';
import MetaDataDisplay from 'modules/common/viewer/cadViewer/addOns/MetaDataDisplay';
import SelectorCumulativeInfo from 'modules/common/viewer/cadViewer/addOns/SelectorCumulativeInfo';
import VolumeAreaWeightDisplay from 'modules/common/viewer/cadViewer/addOns/VolumeAreaWeightDisplay';
import { getShowDxfControls } from 'modules/common/viewer/cadViewer/data/reducer';
import {
  getActiveFileProperties,
  getIsActiveFile3DRenderable,
} from 'modules/common/viewer/data/reducer';

const Wrapper = styled.div`
  bottom: 10px;
  color: ${(props) => (props.showDxfControls ? 'black' : 'white')};
  position: absolute;
  right: 20px;
  z-index: 2;
`;

const connector = connect(
  (state) => ({
    activeFileProperties: getActiveFileProperties(state),
    isActiveFile3DRenderable: getIsActiveFile3DRenderable(state),
    showDxfControls: getShowDxfControls(state),
  }),
  null,
);

const CADViewerInfo = ({
  activeFileProperties,
  isActiveFile3DRenderable,
  showDxfControls,
}) => (
  <Wrapper showDxfControls={showDxfControls}>
    <SelectorCumulativeInfo isEnabled={isActiveFile3DRenderable} />
    <MeasurementComparison isEnabled={isActiveFile3DRenderable} />
    <MetaDataDisplay isEnabled={isActiveFile3DRenderable} />
    <VolumeAreaWeightDisplay
      isEnabled={isActiveFile3DRenderable}
      properties={activeFileProperties}
    />
  </Wrapper>
);

export default connector(CADViewerInfo);
